<template>
  <div class="w-full flex flex-col gap-2">
    <!-- Label -->
    <label
      class="text-[#121212] font-semibold text-[16px] leading-[24px] flex items-center gap-1"
      style="font-family: 'Open Sans'; font-weight: 600"
    >
      {{ label }}
      <span
        v-if="required"
        class="text-[#E25C5C] font-[500] text-[16px] leading-[24px]"
        >*</span
      >
    </label>

    <!-- Email Tags Input Container -->
    <vue3-tags-input
      :tags="modelValue"
      placeholder="e.g. name@domain.com"
      @on-tags-changed="handleEmailsChange"
      :add-tag-on-keys="[32, 188, 13]"
      :validate="emailValidation"
      class="custom-tags-input w-full border border-[#CCCCCC] rounded-[8px] gap-[8px] px-[12px] pt-[12px] pb-[80px] flex items-center"
      :class="{ 'border-red-500': errorMessage }"
    />

    <!-- Helper Message -->
    <p class="text-gray-500 text-[14px]">
      Please click on 'Space' or 'Enter' after each email.
    </p>

    <!-- Error Message -->
    <p v-if="errorMessage" class="text-red-500 text-[14px] text-center">
      {{ errorMessage }}
    </p>
  </div>
</template>
    
  <script setup>
import { defineProps, defineModel } from "vue";
import Vue3TagsInput from "vue3-tags-input";

defineProps({
  label: String,
  required: { type: Boolean, default: false },
  errorMessage: String,
});

const modelValue = defineModel();

const handleEmailsChange = (currEmails) => {
  modelValue.value = currEmails;
};

const emailValidation = (value) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(value);
};
</script>
  
  <style scoped>
/* Make the input inside tags input fill full width & height */
.custom-tags-input {
  flex: 1;
  background: transparent;
  outline: none;
  width: 100%;
  height: 100%;
}

/* Custom styles for tags */
::v-deep(.v3ti-tag) {
  background: #009c87 !important;
  border-radius: 100px !important;
  padding-inline: 10px !important;
}

/* Remove button inside tags */
::v-deep(.v3ti-remove-tag) {
  color: #0d423d !important;
  transition: color 0.3s !important;
  transform: translate(4px, -1px) !important;
}

::v-deep(.v3ti-remove-tag:hover) {
  color: #ffffff !important;
}

/* Error state */
.border-red-500 {
  border: 1px solid rgb(248 113 113) !important;
}
</style>
  